var React = require('react');

var TrackType = React.PropTypes.shape({
    name: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired,
    album: React.PropTypes.string,
    artist: React.PropTypes.string,
    year: React.PropTypes.string,
    image: React.PropTypes.string
  }),
  ClassNameType = React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.string),
    React.PropTypes.objectOf(React.PropTypes.bool),
    React.PropTypes.func,
    React.PropTypes.string
  ]),
  PlaylistType = React.PropTypes.shape({
    name: React.PropTypes.string.isRequired,
    playlist: React.PropTypes.arrayOf(TrackType)
  }),
  PlaylistsType = React.PropTypes.arrayOf(PlaylistType);

module.exports = {
  ClassNameType: ClassNameType,
  TrackType: TrackType,
  PlaylistType: PlaylistType,
  PlaylistsType: PlaylistsType
};



// WEBPACK FOOTER //
// ./src/app/components/types.jsx